import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect, useRef } from 'react';
import { Tooltip } from '@hose/eui';
import './index.module.less';
export default function TooltipEllipsis(props) {
    var childrenRef = useRef(null);
    var children = props.children, title = props.title, width = props.width, placement = props.placement, other = __rest(props, ["children", "title", "width", "placement"]);
    var _a = __read(useState(false), 2), showTooltip = _a[0], setShowTooltip = _a[1];
    useEffect(function () {
        var timer = setTimeout(function () {
            validShowTooltip();
        }, 0);
        return function () { return clearTimeout(timer); };
    }, [title, width, children]);
    var validShowTooltip = function () {
        if (!childrenRef.current) {
            return;
        }
        var _a = childrenRef.current, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
        setShowTooltip(scrollWidth > clientWidth);
    };
    var refChildren = function (ref) {
        childrenRef.current = ref;
    };
    var renderChildren = function () {
        return (React.cloneElement(React.createElement("span", { className: "ellipsis-children" }, children), {
            ref: refChildren
        }));
    };
    if (showTooltip) {
        return (React.createElement(Tooltip, __assign({ title: title, trigger: "hover", placement: placement || "top" }, other), renderChildren()));
    }
    return renderChildren();
}
